<template>
  <div>
    <div>
      <div id="scribe_info" v-bind:class="{ copyColors: doingCopy }">
        <p>{{ infoDocCount }}</p>

        <span class="mb-4">
          <span
            ><span class="heading application-heading">TOP EVENTS: </span></span
          >{{ infoTopText }}
        </span>
        <br v-if="doingCopy" />
        <br v-if="doingCopy" />

        <div v-if="infoTopStories && infoTopStories.length">
          <div
            v-for="(story, index) in infoTopStories"
            :key="index"
            class="mb-4"
          >
            <scribe-info-article
              :story="story"
              :doing-copy="doingCopy"
              :location-name="locationName"
            ></scribe-info-article>
          </div>
        </div>

        <br v-if="doingCopy" />
        <div class="mt-5">
          <span class="heading application-heading">STABILITY: </span>
          {{ infoPulse }}
        </div>

        <br v-if="doingCopy" />
        <div
          v-if="
            (infoExplanationText ||
              (infoExplanationStories && infoExplanationStories.length))
          "
          class="mt-5"
        >
          <span
            ><span class="heading application-heading"
              >EXPLANATION:
            </span></span
          ><span v-html="infoExplanationText"></span>
        </div>
        <br v-if="doingCopy" />

        <div v-if="infoExplanationStories && infoExplanationStories.length">
          <div
            v-for="(story, index) in infoExplanationStories"
            :key="index"
            class="mb-4"
          >
            <scribe-info-article
              :story="story"
              :doing-copy="doingCopy"
              :location-name="locationName"
            ></scribe-info-article>
          </div>
        </div>

        <br v-if="doingCopy" />
        <div class="mt-5">
          <span class="heading application-heading">HOTSPOTS: </span>
          {{ infoHotspotsText }}
        </div>
        <br v-if="doingCopy" />
        <div class="mt-5">
          <span
            v-if="
              infoHotspotsLocation &&
              infoHotspotsStories &&
              infoHotspotsStories.length
            "
            class="heading application-heading"
          >
            {{ infoHotspotsLocation }}
          </span>
        </div>

        <div v-if="infoHotspotsStories && infoHotspotsStories.length">
          <div v-for="(story, index) in infoHotspotsStories" :key="index">
            <scribe-info-article
              :story="story"
              :doing-copy="doingCopy"
              :location-name="locationName"
            ></scribe-info-article>
          </div>
        </div>
      </div>
    </div>
    <v-overlay :absolute="true" :value="screenShotting">
      <div class="copy-overlay-indicator">
        <v-icon size="50" color="white">fas fa-check</v-icon>
        <div><span class="application-heading">Copied</span></div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import lodashGet from "lodash/get";

import {
  getTopicsStringFromTopicsScores,
  convertTopicScoresFromFieldToApiName,
} from "@/services/events/topics.service";
import { getFormatted } from "@/common/date.utilities";
import { EVENT_CATEGORIES, EVENT_ACTIONS } from "@/common/constants/analytics";

export default {
  name: "ScribeInfo",
  components: {
    ScribeInfoArticle: () => import("@/components/scribe/ScribeInfoArticle"),
  },
  data: function () {
    return {
      doingCopy: false,
      screenShotting: false,
    };
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    copyScribeToClipboard: {
      type: String,
    },
    locationName: {
      type: String,
    },
  },
  computed: {
    infoDocCount() {
      if (lodashGet(this.info, "doc_count.web")) {
        return this.info.doc_count.web;
      }
      return null;
    },
    infoPulse() {
      if (lodashGet(this.info, "pulse.web")) {
        return this.info.pulse.web;
      }
      return null;
    },
    infoHotspotsText() {
      if (lodashGet(this.info, "hotspots.paragraph.web")) {
        return this.info.hotspots.paragraph.web;
      }
      return null;
    },
    infoHotspotsLocation() {
      if (lodashGet(this.info, "hotspots")) {
        return this.getLocationName(this.info.hotspots);
      }
      return null;
    },
    infoHotspotsStories() {
      if (lodashGet(this.info, "hotspots.events")) {
        let res = JSON.parse(
          JSON.stringify(lodashGet(this.info, "hotspots.events"))
        );
        for (let i = 0; i < res.length; i++) {
          res[i] = this.addDisplayProperties(res[i]);
        }
        return res;
      }
      return null;
    },
    infoTopText() {
      if (lodashGet(this.info, "top_events.paragraph.web")) {
        return this.info.top_events.paragraph.web;
      }
      return null;
    },
    infoTopStories() {
      if (lodashGet(this.info, "top_events.events")) {
        let res = JSON.parse(
          JSON.stringify(lodashGet(this.info, "top_events.events"))
        );
        for (let i = 0; i < res.length; i++) {
          res[i] = this.addDisplayProperties(res[i]);
        }
        return res;
      }
      return null;
    },
    infoExplanationText() {
      if (lodashGet(this.info, "explanation.paragraph.web")) {
        return this.info.explanation.paragraph.web;
      }
      return null;
    },
    infoExplanationStories() {
      if (lodashGet(this.info, "explanation.events")) {
        let res = JSON.parse(
          JSON.stringify(lodashGet(this.info, "explanation.events"))
        );
        for (let i = 0; i < res.length; i++) {
          res[i] = this.addDisplayProperties(res[i]);
        }
        return res;
      }
      return null;
    },
  },
  methods: {
    addDisplayProperties(event) {
      if (lodashGet(event, "properties.formatted.topic_scores")) {
        event.properties.formatted.topic_scores = convertTopicScoresFromFieldToApiName(
          event.properties.formatted.topic_scores
        );

        let thresholdType =
          lodashGet(event, "properties.formatted.type") === "twitter"
            ? "twitter"
            : "cluster";

        event.properties.displayTopic = getTopicsStringFromTopicsScores(
          event.properties.formatted.topic_scores,
          thresholdType
        );
      }
      if (lodashGet(event, "properties['@timestamp']")) {
        event.properties.displayTime = getFormatted(
          event.properties["@timestamp"]
        );
      }
      return event;
    },
    async doCopyToClipboard() {
      this.screenShotting = true;
      setTimeout(() => {
        this.screenShotting = false;
      }, 1000);
      this.doingCopy = true;
      this.$nextTick(async () => {
        var range = document.createRange();
        range.selectNode(document.getElementById("scribe_info"));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        this.doingCopy = false;
      });
    },
    getLocationName(item) {
      let loc = [];
      if (lodashGet(item, "location.city")) {
        loc.push(item.location.city);
      }
      if (lodashGet(item, "location.state")) {
        loc.push(item.location.state);
      }
      if (lodashGet(item, "location.country")) {
        loc.push(item.location.country);
      }
      if (loc.length) {
        return "Near " + loc.join(", ");
      }
      return null;
    },
  },
  watch: {
    copyScribeToClipboard: function () {
      this.doCopyToClipboard();
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.scribe,
        EVENT_ACTIONS.clicked,
        "Copy To Clipboard"
      );
    },
  },
};
</script>

<style scoped>
.heading {
  font-size: 16px;
  text-transform: capitalize;
}
.copyColors {
  color: black;
  background-color: white;
}
.v-overlay {
  left: 0px !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-overlay--active.v-overlay {
  background-color: rgba(0, 0, 0, 0.75) !important;
}

.copy-overlay-indicator {
  width: 120px;
  height: 120px;
  background-color: green;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  font-size: large;
}
#scribe_info {
  white-space: pre-line;
}
</style>
